export interface Film {
  id: string;
  title: string;
  type: string;
  year: number;
  cover: string;
  summary: string;
  director: string;
  cast: string;
  duration: string;
  platform: string;
  rating: number;
  genres: string[];
  updatedAt: string;
  gallery: string[];
}

export const films: Film[] = [
  {
    id: 'dhyx',
    title: '深海回响',
    type: '电影',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20lone%20silhouette%20standing%20before%20a%20vast%20deep%20blue%20ocean%20wave%20with%20a%20warm%20orange%20horizon%20glow%2C%20moody%20artistic%20editorial%20design%2C%20high%20contrast%2C%20minimal%20elegant%20composition&width=600&height=800&seq=film-dhyx-01&orientation=portrait',
    summary:
      '一场跨越十年的深海救援行动，将一名潜水工程师的秘密与一座沿海城市的命运紧紧缠绕在一起。在压力与黑暗之中，她必须重新面对自己最深的恐惧。',
    director: '松本凌',
    cast: '神宫寺奈绪、白石悠真、佐仓玲',
    duration: '124 分钟',
    platform: '全国院线',
    rating: 8.6,
    genres: ['剧情', '悬疑', '灾难'],
    updatedAt: '2024-08-12',
    gallery: [
      'https://readdy.ai/api/search-image?query=moody%20cinematic%20film%20still%20of%20a%20diver%20descending%20into%20deep%20dark%20blue%20water%20with%20a%20single%20warm%20amber%20light%20beam%2C%20artistic%20atmospheric%20composition&width=1200&height=675&seq=film-dhyx-still-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=dramatic%20cinematic%20film%20still%20of%20a%20stormy%20coastal%20city%20at%20dusk%20with%20orange%20sunset%20reflecting%20on%20deep%20blue%20sea%2C%20editorial%20color%20grading&width=1200&height=675&seq=film-dhyx-still-b&orientation=landscape',
    ],
  },
  {
    id: 'jmos',
    title: '静默之夏',
    type: '电影',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20of%20a%20young%20woman%20silhouette%20in%20a%20quiet%20sunlit%20room%20by%20the%20window%2C%20warm%20orange%20light%20against%20muted%20deep%20blue%20shadows%2C%20artistic%20minimal%20nostalgic%20mood&width=600&height=800&seq=film-jmos-01&orientation=portrait',
    summary:
      '一个没有对白的夏天，一段被时间搁置的告别。神宫寺奈绪以近乎默片式的表演，讲述一个女人在故乡小镇重新学会倾听自己的故事。',
    director: '小林纪子',
    cast: '神宫寺奈绪、高桥彗',
    duration: '108 分钟',
    platform: '全国院线',
    rating: 8.2,
    genres: ['剧情', '文艺'],
    updatedAt: '2023-11-02',
    gallery: [
      'https://readdy.ai/api/search-image?query=nostalgic%20cinematic%20still%20of%20an%20empty%20japanese%20countryside%20town%20in%20summer%20with%20warm%20orange%20afternoon%20light%20and%20deep%20blue%20shadows%2C%20editorial%20photography&width=1200&height=675&seq=film-jmos-still-a&orientation=landscape',
    ],
  },
  {
    id: 'djjs',
    title: '东京纪事',
    type: '电视剧',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20tv%20series%20poster%20of%20a%20city%20skyline%20at%20night%20with%20warm%20orange%20window%20lights%20against%20deep%20blue%20dusk%20sky%2C%20elegant%20urban%20editorial%20design%2C%20vertical%20composition&width=600&height=800&seq=film-djjs-01&orientation=portrait',
    summary:
      '在东京一间深夜咖啡馆里，五位素不相识的人因一杯咖啡相遇。剧集以片段式叙事勾勒都市人的孤独与温柔，神宫寺奈绪饰演的店主是全剧的情感锚点。',
    director: '中村岳',
    cast: '神宫寺奈绪、藤井飒、森川千鹤',
    duration: '全 10 集',
    platform: '星野视频',
    rating: 8.9,
    genres: ['剧情', '都市', '治愈'],
    updatedAt: '2024-09-20',
    gallery: [
      'https://readdy.ai/api/search-image?query=cozy%20night%20cafe%20interior%20with%20warm%20amber%20lamps%20and%20rain%20on%20windows%2C%20deep%20blue%20evening%20tones%2C%20cinematic%20film%20still%2C%20editorial%20composition&width=1200&height=675&seq=film-djjs-still-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=lonely%20pedestrian%20crossing%20a%20neon%20lit%20tokyo%20street%20at%20night%20with%20warm%20orange%20reflections%20and%20deep%20blue%20shadows%2C%20moody%20cinematic%20still&width=1200&height=675&seq=film-djjs-still-b&orientation=landscape',
    ],
  },
  {
    id: 'anliu',
    title: '暗流之城',
    type: '电视剧',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=crime%20thriller%20poster%20of%20a%20narrow%20rainy%20alley%20with%20a%20single%20warm%20orange%20street%20lamp%20cutting%20through%20deep%20blue%20darkness%2C%20tense%20cinematic%20editorial%20design&width=600&height=800&seq=film-anliu-01&orientation=portrait',
    summary:
      '一桩悬而未决的旧案，让身为记者的她卷入城市地下世界的暗流。真相与谎言只隔一层薄雾，而她要做的，是把雾一层层拨开。',
    director: '河合隆',
    cast: '神宫寺奈绪、藤井飒',
    duration: '全 12 集',
    platform: '星野视频',
    rating: 8.4,
    genres: ['悬疑', '犯罪', '剧情'],
    updatedAt: '2023-12-18',
    gallery: [
      'https://readdy.ai/api/search-image?query=tense%20cinematic%20still%20of%20a%20detective%20silhouette%20in%20a%20rainy%20dark%20blue%20city%20alley%20with%20warm%20orange%20glow%2C%20moody%20thriller%20atmosphere&width=1200&height=675&seq=film-anliu-still-a&orientation=landscape',
    ],
  },
  {
    id: 'xgzl',
    title: '星光旅程',
    type: '综艺',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=cheerful%20variety%20show%20poster%20with%20stage%20spotlights%20in%20warm%20orange%20and%20deep%20blue%2C%20confetti%20and%20elegant%20typography%20space%2C%20energetic%20editorial%20poster%20design&width=600&height=800&seq=film-xgzl-01&orientation=portrait',
    summary:
      '一档主打「真实旅行 + 即兴表演」的综艺。神宫寺奈绪与嘉宾们走进日本各地小城，用镜头记录真实的欢笑与意外。',
    director: '节目组',
    cast: '神宫寺奈绪、常驻嘉宾团',
    duration: '每期 75 分钟 · 全 12 期',
    platform: '星野视频',
    rating: 8.1,
    genres: ['真人秀', '旅行', '喜剧'],
    updatedAt: '2024-10-01',
    gallery: [
      'https://readdy.ai/api/search-image?query=bright%20variety%20show%20studio%20stage%20with%20warm%20orange%20spotlights%20and%20deep%20blue%20backdrop%2C%20energetic%20cinematic%20still&width=1200&height=675&seq=film-xgzl-still-a&orientation=landscape',
    ],
  },
  {
    id: 'yxdb',
    title: '月下独白',
    type: '电影',
    year: 2022,
    cover:
      'https://readdy.ai/api/search-image?query=poetic%20cinematic%20poster%20of%20a%20lone%20woman%20silhouette%20under%20a%20huge%20moon%20with%20warm%20orange%20glow%20and%20deep%20blue%20night%20sky%2C%20minimal%20artistic%20composition&width=600&height=800&seq=film-yxdb-01&orientation=portrait',
    summary:
      '一名话剧演员在人生低谷期回到剧场，用一个个夜晚的独白重新拼凑自己。影片以舞台与生活交织的结构，呈现表演与真实之间模糊的边界。',
    director: '松本凌',
    cast: '神宫寺奈绪、佐仓玲',
    duration: '96 分钟',
    platform: '艺术院线',
    rating: 7.9,
    genres: ['剧情', '文艺'],
    updatedAt: '2022-10-08',
    gallery: [
      'https://readdy.ai/api/search-image?query=empty%20theatre%20stage%20with%20a%20single%20warm%20orange%20spotlight%20on%20a%20silhouette%20against%20deep%20blue%20darkness%2C%20poetic%20cinematic%20still&width=1200&height=675&seq=film-yxdb-still-a&orientation=landscape',
    ],
  },
  {
    id: 'crcs',
    title: '春日方程式',
    type: '电视剧',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=bright%20romantic%20drama%20poster%20of%20a%20couple%20silhouette%20among%20spring%20cherry%20blossoms%20with%20warm%20orange%20sunlight%20and%20soft%20deep%20blue%20sky%2C%20elegant%20editorial%20design&width=600&height=800&seq=film-crcs-01&orientation=portrait',
    summary:
      '一位数学老师与一位花艺师在一场毕业典礼上相遇。两人用各自的方式解着同一道题——关于爱、关于成长的那道方程式。',
    director: '小林纪子',
    cast: '神宫寺奈绪、高桥彗',
    duration: '全 8 集',
    platform: '星野视频',
    rating: 8.3,
    genres: ['爱情', '剧情', '治愈'],
    updatedAt: '2024-06-15',
    gallery: [
      'https://readdy.ai/api/search-image?query=romantic%20cinematic%20still%20of%20two%20silhouettes%20under%20cherry%20blossom%20trees%20with%20warm%20orange%20sunset%20light%20and%20deep%20blue%20shadows%2C%20editorial%20composition&width=1200&height=675&seq=film-crcs-still-a&orientation=landscape',
    ],
  },
  {
    id: 'wdll',
    title: '雾都来信',
    type: '电影',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=literary%20cinematic%20poster%20of%20a%20hand%20holding%20an%20old%20letter%20before%20a%20foggy%20deep%20blue%20city%20with%20warm%20orange%20lamp%20glow%2C%20mysterious%20elegant%20composition&width=600&height=800&seq=film-wdll-01&orientation=portrait',
    summary:
      '一封迟到了二十年的信，揭开两代人之间的沉默。她循着字迹走进雾中，也在雾中找到了那个一直等自己的人。',
    director: '河合隆',
    cast: '神宫寺奈绪、白石悠真',
    duration: '116 分钟',
    platform: '全国院线',
    rating: 8.0,
    genres: ['剧情', '悬疑'],
    updatedAt: '2023-09-27',
    gallery: [
      'https://readdy.ai/api/search-image?query=mysterious%20cinematic%20still%20of%20a%20foggy%20old%20city%20street%20at%20night%20with%20warm%20orange%20street%20lamps%20through%20deep%20blue%20mist%2C%20editorial%20composition&width=1200&height=675&seq=film-wdll-still-a&orientation=landscape',
    ],
  },
  {
    id: 'zrsys',
    title: '真人实验室',
    type: '综艺',
    year: 2023,
    cover:
      'https://readdy.ai/api/search-image?query=playful%20game%20show%20poster%20with%20geometric%20shapes%20in%20warm%20orange%20and%20deep%20blue%2C%20bold%20modern%20editorial%20poster%20design%20with%20clean%20spacing&width=600&height=800&seq=film-zrsys-01&orientation=portrait',
    summary:
      '一档以「极限情境实验」为核心的综艺。神宫寺奈绪以观察员身份加入，用冷静又毒舌的点评，见证普通人在极端设定下的真实反应。',
    director: '节目组',
    cast: '神宫寺奈绪、实验观察团',
    duration: '每期 60 分钟 · 全 10 期',
    platform: '星野视频',
    rating: 7.7,
    genres: ['真人秀', '实验'],
    updatedAt: '2023-07-11',
    gallery: [
      'https://readdy.ai/api/search-image?query=modern%20game%20show%20set%20with%20geometric%20panels%20in%20warm%20orange%20and%20deep%20blue%20lighting%2C%20clean%20editorial%20cinematic%20still&width=1200&height=675&seq=film-zrsys-still-a&orientation=landscape',
    ],
  },
  {
    id: 'byg',
    title: '半月光',
    type: '电视剧',
    year: 2022,
    cover:
      'https://readdy.ai/api/search-image?query=melancholic%20drama%20poster%20of%20a%20woman%20silhouette%20by%20a%20harbor%20at%20half%20moon%20night%20with%20warm%20orange%20reflection%20on%20deep%20blue%20water%2C%20poetic%20editorial%20design&width=600&height=800&seq=film-byg-01&orientation=portrait',
    summary:
      '在北方的一座港口城市，一段横跨十年的感情在两个半月的月圆月缺之间反复靠近与远离。慢节奏的剧集，把时间本身当成主角。',
    director: '中村岳',
    cast: '神宫寺奈绪、森川千鹤',
    duration: '全 10 集',
    platform: '星野视频',
    rating: 8.5,
    genres: ['剧情', '爱情'],
    updatedAt: '2022-04-19',
    gallery: [
      'https://readdy.ai/api/search-image?query=quiet%20harbor%20at%20night%20with%20half%20moon%20and%20warm%20orange%20light%20reflecting%20on%20deep%20blue%20water%2C%20poetic%20cinematic%20still&width=1200&height=675&seq=film-byg-still-a&orientation=landscape',
    ],
  },
  {
    id: 'yzws',
    title: '银座往事',
    type: '电影',
    year: 2021,
    cover:
      'https://readdy.ai/api/search-image?query=retro%20cinematic%20poster%20of%20an%20elegant%20woman%20in%20a%20vintage%20coat%20before%20a%20deep%20blue%20night%20city%20with%20warm%20orange%20neon%20signs%2C%20nostalgic%20editorial%20design&width=600&height=800&seq=film-yzws-01&orientation=portrait',
    summary:
      '上世纪八十年代的银座，一位舞厅歌手用歌声记下整个时代的喧嚣与落寞。这是一个关于青春、梦想与告别的复古故事。',
    director: '松本凌',
    cast: '神宫寺奈绪、佐仓玲、白石悠真',
    duration: '132 分钟',
    platform: '全国院线',
    rating: 8.1,
    genres: ['剧情', '年代'],
    updatedAt: '2021-12-03',
    gallery: [
      'https://readdy.ai/api/search-image?query=retro%201980s%20neon%20lit%20girza%20street%20at%20night%20with%20warm%20orange%20signs%20against%20deep%20blue%20sky%2C%20nostalgic%20cinematic%20still&width=1200&height=675&seq=film-yzws-still-a&orientation=landscape',
    ],
  },
  {
    id: 'yhc',
    title: '夜航船',
    type: '电视剧',
    year: 2024,
    cover:
      'https://readdy.ai/api/search-image?query=atmospheric%20thriller%20poster%20of%20a%20ferry%20crossing%20dark%20deep%20blue%20water%20at%20night%20with%20warm%20orange%20deck%20lights%2C%20mysterious%20elegant%20editorial%20design&width=600&height=800&seq=film-yhc-01&orientation=portrait',
    summary:
      '一艘夜间渡轮上的六名乘客，各自带着不能说出口的秘密。随着航线推进，真相在夜色与海浪声中被一点点推向甲板。',
    director: '河合隆',
    cast: '神宫寺奈绪、藤井飒、高桥彗',
    duration: '全 9 集',
    platform: '星野视频',
    rating: 8.7,
    genres: ['悬疑', '剧情'],
    updatedAt: '2024-10-05',
    gallery: [
      'https://readdy.ai/api/search-image?query=night%20ferry%20on%20dark%20deep%20blue%20ocean%20with%20warm%20orange%20deck%20lights%20and%20lonely%20passenger%20silhouette%2C%20moody%20cinematic%20still&width=1200&height=675&seq=film-yhc-still-a&orientation=landscape',
    ],
  },
];